/**
 * Portlet View
 */

define(function(require, exports, module) {
    var _ = require('underscore');
    var i18n = require('i18n');
    var BaseView = require('common/base.view');
    var user = require('user');
    var core = require('core');

    /**
     * @class
     * @name PortletView
     * @augments BaseView
     */
    var PortletView = BaseView.extend(
        /** @lends PortletView */
        {
            constructor: function(options) {
                this.options = options && options.model
                    ? options.model.toJSON()
                    : options;

                BaseView.apply(this, arguments);
            },

            _setRender: function() {
                if (!this.checkAccess()) {
                    this.render = function() {
                        this.renderGuest();
                        return this;
                    };
                } else {
                    this.render = _.wrap(this.render, function(render) {
                        var $portletWrapperEl = this.$el;
                        var $portlet = this._renderPortletWrapper();
                        var args = [].slice.call(arguments, 1);
                        // set this.$el to portlet
                        this.setElement($portlet);
                        render.apply(this, args);
                        // rollback this.$el to wrapper
                        this.setElement($portletWrapperEl);

                        core.trigger('portlet:rendered', this);

                        return this;
                    });
                }
            },

            initialize: function() {
                this.portletHasMounted = false;
            },

            render: function() {
                if (this.options.success === false) {
                    this.$el.html(this.tmpl('common.messages', {
                        content: i18n.t('playtech.mobile.system.portlet.portletInitializingFailed')
                    }));
                }

                return this;
            },

            /** Can be implemented in child classes*/
            portletDidMount: _.noop,

            /**
             * Render error for portlet
             * @return {BaseView}
             */
            renderError: function() {
                this._renderPortletWrapper().html(this.tmpl('common.messages', {
                    content: i18n.t('playtech.mobile.system.portlet.portletCouldNotBeRendered')
                }));

                return this;
            },

            /**
             * Render guest placeholder
             * @return {BaseView}
             */
            renderGuest: function() {
                this._renderPortletWrapper().html(this.tmpl('portlet.guest', user.toJSON()));

                return this;
            },

            _renderPortletWrapper: function() {
                return this.$el;
            },

            close: function() {
                BaseView.prototype.close.apply(this, arguments);

                this.model && this.model.close();
            }
        }
    );

    module.exports = PortletView;
});
